import Cookies from 'js-cookie'
import store from 'vuex'
const TokenKey = 'Admin-Token'
const MenusKey = "Admin-menus"

import { addPermission ,getPermissionMenuListForTabBar}  from '@/api/systemData'


export function getToken() {
    console.log("cookies",Cookies);

    return Cookies.get(TokenKey)
}

export function setToken(token) {
    console.log("TokenKey", TokenKey)
    console.log("token", token)
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}


export function getMenu() {
    return sessionStorage.getItem('menus');
    // return Cookies.get(MenusKey)
    // getPermissionMenuListForTabBar().then((res)=>{
    //     if(res.code == 10000){
    //         const pidSelect = [];
    //         if(res.data != null && res.data.length > 0){
    //         console.log("res.data--menu",res.data);
    //         let resultMunuList = res.data;
    //         for(let i=0;i<resultMunuList.length;i++){
    //             let obj={};
    //             obj.menuComponent = resultMunuList[i].menuComponent;
    //             obj.menuName = resultMunuList[i].menuName;
    //             obj.menuRedirectUrl = resultMunuList[i].menuRedirectUrl;
    //             obj.menuTableTitle = resultMunuList[i].menuTableTitle;

    //             pidSelect.push(obj);
    //         }
    //         console.log("pidSelect001",pidSelect);
    //         this.$store.dispatch('menu/setMenu',pidSelect); 
    //         // this.$store.dispatch('setMenu',pidSelect); 
    //         console.log("menus-store001",this.$store.getters.menus);
    //         }
    //     }
    // })
}

export function setMenus(menus) {
    console.log("menus",menus);
    // return Cookies.set(MenusKey, menus)
    return sessionStorage.setItem('menus', JSON.stringify(menus));
}

export function removeMenus() {
    return Cookies.remove(MenusKey)
}


